<template>
  <v-card class="white rounded-lg">
    <sanad-tabs :type="type"></sanad-tabs>
    <v-card-title class="secondary--text">
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn :block="isXs" small depressed @click="reorder('date')" class="rounded-lg accent white--text mr-md-1"
        >مرتب کردن کد اسناد بر اساس تاریخ
      </v-btn>
      <v-btn
        :block="isXs"
        small
        depressed
        @click="reorder('local_id')"
        class="rounded-lg accent white--text mr-md-1 mt-1 mt-md-0"
        >مرتب کردن کد اسناد بر اساس عطف
      </v-btn>
      <v-btn
        :block="isXs"
        small
        depressed
        @click="reorder(null)"
        class="rounded-lg accent white--text mr-md-1 mt-1 mt-md-0"
        >بازگردانی کد اسناد به حالت اولیه
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div @mouseenter="normal_view">
        <m-datatable
          :export-url="exportUrl"
          :show-filter-row="true"
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
          @dblclick:row="(e, row) => $router.push(to(row.item))"
          ref="datatable"
        >
          <template #item.detail="{ item }">
            <detail-link :to="to(item)" />
          </template>
        </m-datatable>
      </div>
    </v-card-text>
    <v-row justify="center">
      <v-dialog
        v-model="confirmDialog"
        class="rounded-lg"
        persistent
        @click:outside="confirmDialog = false"
        max-width="400"
      >
        <v-card class="rounded-lg pa-2">
          <v-card-title class="error--text text-h5"> توجه! </v-card-title>
          <v-card-text class="pt-3 pr-7"> با انجام این عملیات کد اسناد تغییر میکنند. میخواهید ادامه دهید؟ </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" class="rounded-lg" depressed @click="confirmDialog = false"> خیر </v-btn>
            <v-btn depressed class="rounded-lg" color="success" @click="reorderSanads"> بله </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import { jsPDF } from "jspdf";
import XLSX from "xlsx";
import SanadTabs from "@/views/panel/sanad/SanadTabs";

export default {
  name: "SanadsList",
  components: {SanadTabs},
  props: {
    type: {
      default: "all",
    },
  },
  data() {
    return {
      confirmDialog: false,
      order: null,
      filters: {},
      users: [],
      names: [],
    };
  },
  computed: {
    url() {
      this.filters = {};
      switch (this.type) {
        case "all":
          return "reports/lists/sanads";
        case "unbalanced":
          this.filters = { is_sanad_unbalanced: true };
          return "reports/lists/sanads/unbalanced";
        case "empty":
          this.filters = { is_sanad_empty: true };
          return "reports/lists/sanads/empty";
        case "notDefined":
          this.filters = { is_defined: false };
          return "reports/lists/sanads";
      }
    },
    exportUrl() {
      return "reports/lists/sanads";
    },
    title() {
      switch (this.type) {
        case "all":
          return this.setDocumentTitle("لیست اسناد حسابداری");
        case "unbalanced":
          return this.setDocumentTitle("لیست اسناد نامتوازن");
        case "empty":
          return this.setDocumentTitle("لیست اسناد خالی");
        case "notDefined":
          return this.setDocumentTitle("لیست اسناد غیر قطعی");
      }
    },
    headers() {
      let headers = [
        {
          text: "عطف",
          value: "local_id",
        },
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
        },
        {
          text: "توضیحات",
          value: "explanation",
        },

        {
          text: "بدهکار",
          value: "bed",
        },
        {
          text: "بستانکار",
          value: "bes",
        },
        {
          text: "قطعی",
          value: "is_defined",
          type: "boolean",
          show: this.type != "notDefined",
        },
        {
          text: "سیستمی",
          value: "is_auto_created",
          type: "boolean",
        },
        {
          text: "کاربر ایجاد کننده",
          value: "created_by.name",
          items: this.names,
        },
      ];

      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  mounted() {
    this.request({
      url: this.endpoint("companies/companyUsers/"),
      method: "get",
      success: (data) => {
        for (let t in data) {
          this.users.push({
            name: data[t]["user"]["name"],
            id: data[t]["user"]["id"],
          });
          this.names.push(data[t]["user"]["name"]);
        }
      },
    });
  },

  methods: {
    list_export() {
      this.$refs.datatable.$data.list_view = true;
    },
    normal_view() {
      this.$refs.datatable.$data.list_view = false;
    },
    cl(e, row) {
      console.log(this.to(row.item));
    },
    to(item) {
      return {
        name: "SanadForm",
        params: {
          id: item.id,
        },
      };
    },
    confirm() {
      if (confirm("با انجام این عملیات کد اسناد تغییر میکنند. میخواهید ادامه دهید؟")) {
        if (confirm("از انجام این عملیات اطمینان دارید؟")) {
          return true;
        }
      }
      return false;
    },
    reorder(input_order) {
      this.confirmDialog = true;
      this.order = input_order;
    },
    reorderSanads() {
      this.request({
        url: this.endpoint("sanads/reorder"),
        method: "post",
        data: {
          order: this.order,
        },
        success: (data) => {
          this.successNotify();
          this.$refs.datatable.getDataFromApi();
        },
      });
      this.confirmDialog = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
